<template>
  <div id="LandingPageInvestment">
    <MainLogo />
    <Hero src="../../../assets/landing-investment/hero.jpg">
      <Row>
        <Column :lg="7" />
        <Column :lg="5">
          <h1 class="title">
            {{ $t('title') }}
          </h1>
        </Column>
      </Row>
    </Hero>

    <SectionInvestNow />
    <SectionBigBank />
    <SectionSmartSave />
    <SectionWhyUsAbout />
    <SectionSetup />
    <FooterContact />
    <SectionContacts :doShowOfficeType="false" :title="$t('titleContact')" />
    <FooterLanding />
  </div>
</template>

<script>
import FooterContact from 'views/components/FooterContact'
import FooterLanding from 'views/components/FooterLanding'
import Hero from 'views/components/Hero'
import MainLogo from 'views/components/TopBar/MainLogo'
import Meta from 'views/mixins/Meta'
import SectionBigBank from 'views/components/SectionBigBank'
import SectionContacts from 'views/components/SectionContacts'
import SectionInvestNow from './components/SectionInvestNow'
import SectionSetup from 'views/components/SectionSetup'
import SectionSmartSave from 'views/components/SectionSmartSave'
import SectionWhyUsAbout from 'views/pages/AboutUs/components/SectionWhyUsAbout'

export default {
  mixins: [
    Meta(
      require('@/assets/social/landing-investment.jpg'),
    ),
  ],
  components: {
    FooterContact,
    FooterLanding,
    MainLogo,
    Hero,
    SectionBigBank,
    SectionContacts,
    SectionInvestNow,
    SectionSmartSave,
    SectionWhyUsAbout,
    SectionSetup,
  },
}

</script>

<style lang="scss">
#LandingPageInvestment {
  .MainLogo {
    padding: 1rem 0 0 2rem;
    position: absolute;
    z-index: 2;
  }

  .Hero {
    h1 {
      text-align: left;
    }

    .image img {
      filter: brightness(0.75);
      height: 100%;
    }
  }

  p {
    opacity: 0.8;
  }

  #SectionInvestNow,
  #SectionSmartSave,
  #SectionSetup {
    background-color: $white;
  }

  #SectionBigBank,
  #SectionWhyUsAbout {
    background-color: $grey-lightest;
  }

  #SectionWhyUsAbout {
    .title {
      padding-left: 0;
    }
  }
}
</style>

<i18n>
{
  "lt": {
    "title": "Saulės elektrinė be didelės pradinės investicijos",
    "titleContact": "Susidomėjote? Turite klausimų? Susisiekite!"
  }
}
</i18n>
